import { render, staticRenderFns } from "./CustomerForm.vue?vue&type=template&id=35c7c4d3&scoped=true"
import script from "./CustomerForm.vue?vue&type=script&lang=js"
export * from "./CustomerForm.vue?vue&type=script&lang=js"
import style0 from "./CustomerForm.vue?vue&type=style&index=0&id=35c7c4d3&prod&lang=stylus"
import style1 from "./CustomerForm.vue?vue&type=style&index=1&id=35c7c4d3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35c7c4d3",
  null
  
)

export default component.exports